"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var configureI18next_1 = __importDefault(require("../../config/ConfigureLocalization/configureI18next"));
var i18next_1 = __importDefault(require("i18next"));
var LocalizationProviderRender = /** @class */ (function (_super) {
    __extends(LocalizationProviderRender, _super);
    function LocalizationProviderRender(props) {
        var _this = _super.call(this, props) || this;
        _this.create18n = function () {
            var _a = _this.props, translations = _a.translations, context = _a.context, fallbackLanguages = _a.fallbackLanguages, formats = _a.formats, useXhr = _a.useXhr, xhrCacheId = _a.xhrCacheId, whitelist = _a.whitelist, bindTranslationsToWindow = _a.bindTranslationsToWindow;
            var instance = i18next_1.default.createInstance();
            configureI18next_1.default({
                languageCode: context.languageCode,
                disableAutoDetect: context.disableAutoDetect,
                useXhr: useXhr,
                xhrCacheId: xhrCacheId,
                fallbackLanguages: fallbackLanguages,
                formats: formats,
                translations: translations,
                whitelist: whitelist,
                bindTranslationsToWindow: bindTranslationsToWindow
            }, instance);
            return instance;
        };
        _this.state = {
            i18nInstance: _this.create18n()
        };
        return _this;
    }
    LocalizationProviderRender.prototype.componentDidUpdate = function (prevProps) {
        var context = this.props.context;
        if (context.languageCode && context.languageCode !== prevProps.context.languageCode) {
            var instance = this.state.i18nInstance;
            instance.changeLanguage(context.languageCode);
            this.setState({ i18nInstance: instance });
        }
    };
    LocalizationProviderRender.prototype.render = function () {
        return (React.createElement(react_i18next_1.I18nextProvider, { i18n: this.state.i18nInstance }, this.props.children));
    };
    return LocalizationProviderRender;
}(react_1.Component));
exports.default = LocalizationProviderRender;
